import type { ModuleInput } from "@/lib/types/module"
import { DataType } from "@/lib/types/module"
import type { CompositorConfig } from "@/lib/types/compositor"

/**
 * Derive dynamic input handles from a compositor's config.layers array.
 * Each layer becomes one input handle with type Media.
 * Same pattern as getTextBuilderInputs() in text-builder.ts.
 */
export function getCompositorInputs(config: Record<string, unknown>): ModuleInput[] {
  const layers = (config as Partial<CompositorConfig>).layers
  if (!Array.isArray(layers)) return []

  return layers.map((layer) => ({
    name: layer.id,
    type: DataType.Media,
    required: layer.type === "background",
    handle: true,
    description: layer.name,
  }))
}
